import { clsx } from 'clsx'

import { BluredBubble } from './mkt/blurred-bubble'
import { useFloatingBubblesAnimation } from '../hooks/use-floating-bubbles-animation'

export const BubbledBox: React.FC<
  React.PropsWithChildren<{ className?: string; disabled?: boolean }>
> = ({ children, className = '', disabled = false }) => {
  return (
    <div
      className={clsx(
        className,
        disabled
          ? 'border-[#6F6F6F] bg-[#6F6F6F]'
          : 'border-dark-control-base bg-dark-control-base',
        'relative overflow-hidden border border-opacity-10 bg-opacity-5'
      )}
    >
      {children}

      <FloatingBubble
        disabled={disabled}
        size={52}
        duration={4}
        randomRadius={{ min: 3, max: 20 }}
        className="top-3/4 left-1/2 -translate-x-1/2 -translate-y-1/2"
      />
      <FloatingBubble
        disabled={disabled}
        size={29}
        duration={6}
        randomRadius={{ min: 5, max: 12 }}
        className="top-0 left-2/3 -translate-x-1/2 -translate-y-1/2"
      />
      <FloatingBubble
        disabled={disabled}
        size={32}
        duration={9}
        randomRadius={{ min: 5, max: 15 }}
        className="top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
      />
    </div>
  )
}

const FloatingBubble = ({
  size = 32,
  blur = 15,
  duration = 3,
  randomRadius = { min: 10, max: 30 },
  disabled = false,
  className = '',
}) => {
  const { setTarget } = useFloatingBubblesAnimation({ duration, randomRadius })

  return (
    <div
      className="absolute -inset-4 z-30 overflow-hidden opacity-50"
      ref={(el) => {
        setTarget(el?.children ?? null)
      }}
      style={{
        // match LogoColoredSvg
        WebkitMaskImage: '-webkit-radial-gradient(white, black)',

        clipPath: 'url(#clip-logo-colored-svg)',
      }}
    >
      <BluredBubble
        size={size}
        blur={blur}
        className={clsx(
          'absolute opacity-0',
          disabled && '!bg-[#6F6F6F]',
          className
        )}
      />
    </div>
  )
}
